import { Map } from 'immutable'
import { createSelector } from 'reselect'
import { getIn, get } from 'utils/immutable'

export const featureMetaDataSelector = createSelector(
  getIn(['feature', 'currentFeature', 'feature']),
  (_, props) => props,
  (value, props) =>
    props && props.featureId
      ? value.get(props.featureId)
      : value?.valueSeq().first()
)

export const getFeatureModuleName = createSelector(
  featureMetaDataSelector,
  get('moduleName')
)

const signalsSelectorForModules = getIn(['feature', 'signals'])

export const signalsSelector = createSelector(
  signalsSelectorForModules,
  getFeatureModuleName,
  (allSignals, moduleName) => {
    if (!allSignals || !moduleName) return Map()
    return allSignals.get(moduleName) || Map()
  }
)
